import React from "react"
import PageHeaderWrapper from "../../components/PageHeaderWrapper"
import { connect } from "react-redux"
import { Card, Row, Col, Button, DatePicker, Tooltip, Form, Drawer, notification } from "antd"
import { TableComp, FormUtils as GetAllFormFields } from "sz-react-utils"
import Request, { API_URL } from '../../request';
import moment from "moment";
import _ from 'lodash';
const { RangePicker } = DatePicker;
const activeUser = localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):null;
@Form.create()
class StaffOutDetails extends React.Component {
    state = {
        visible: true,
        outReason: null
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 500);
    }

    componentDidMount() {
    }

    handleSubmit = (e) => {
        let { form, record } = this.props
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            if(!values.outReason) {
                notification.error({ message: 'Please select Out Reason' });
                return
            }
            if ((values.outReason === 'Personal Work' || values.outReason === 'Others') && !values.stopTimer) {
                notification.error({ message: 'Please select Stop Timer' });
                return;
            }
            if((values.outReason === "Others" || values.outReason === "Official Work") && !values.specifyReason) {
                notification.error({ message: 'Please specify reason' });
                return;
            }
            values.reason = `${values.outReason} ${values.specifyReason ? `(${values.specifyReason})` :''}`;
            values.stopTime = values.stopTimer === 'Yes' ? true : false;
            values.status = 'OUT';
            values.outTime = moment();
            values.userId = record.userId;
            values.attendanceDate = moment();
            let response = await Request.updateInOutStatus(values);
            if(response.success) {
                if(values.stopTime === true) {
                    await Request.stopEmployeeTimer({ userId: record.userId, logoutTime: moment(), inOut:true });
                }
                notification.success({
                    message:response.message
                })
            }else {
                notification.error({
                    message:response.message
                })
            }
            this.onClose();
        });
    }

    render() {
        let { record, form: { getFieldDecorator, setFieldsValue } } = this.props;
        const inputTypes = {
            fields: [
                {
                    label: 'Out Reason',
                    key: 'outReason',
                    type: 'select',
                    options: ['Personal Work', 'Official Work', 'Others'],
                    required: true,
                    onChange: v => {
                        this.setState({ outReason: v });
                        setFieldsValue({ outReason: v });
                    }
                },
                {
                    label: 'Specify Reason/Permitted By',
                    key: 'specifyReason',
                    type: 'textarea',
                    hidden: !this.state.outReason,
                    required: true,
                    rows: 4
                },
                {
                    label: 'Stop Timer',
                    key: 'stopTimer',
                    type: 'select',
                    hidden: !(record && record['login_history_details'] !== null && (this.state.outReason === 'Personal Work' || this.state.outReason === 'Others')),
                    required: (record && record['login_history_details'] !== null && (this.state.outReason === 'Personal Work' || this.state.outReason === 'Others')),
                    options: ['Yes', 'No'],
                    onChange: v => {
                        setFieldsValue({ stopTimer: v });
                    }
                }
            ]
        }
        return (
            <Drawer title={`Out Details of ${record.staffName}`} width={720} placement="right" onClose={this.onClose} visible={this.state.visible}>
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields apiurl={API_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}




class StaffInOutTime extends React.Component {
    state = {
        count: 0,
        showOutDrawer: false,
        record: null,
        attendanceDate: {
            from: moment().startOf('day'),
            to: moment().endOf('day')
        }
    }

    componentDidMount() {

    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    updateInStatus = (record) =>{
        let values = {
            status: 'IN',
            inTime: moment(),
            userId: record.userId,
            attendanceDate: moment()
        }
        Request.updateInOutStatus(values).then((response) => {
            if(response.success) {
                notification.success({
                    message:response.message
                })
                this.table.current.reload();
            }else {
                notification.error({
                    message:response.message
                })
            }
        })
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            params.attendanceDate = this.state.attendanceDate;
            params.userBranch = activeUser.userBranch;
            let response = await Request.getStaffInOutTime(params);
            this.setState({ count: response.total });
            return resolve(response);
        })
    }


    showOutDrawer = (record) => {
        this.setState({ showOutDrawer: true, record })
    }

    closeOutDrawer = () => {
        this.setState({ showOutDrawer: false, record: null }, ()=>{
            this.table.current.reload();
        })
    }

    chooseRangerPicker = (date, dateString) => {
        this.setState(
            {
                attendanceDate: {
                    from: date[0],
                    to: date[1],
                },
            },
            () => {
                this.table.current.reload();
            }
        );
    };

    onOk = value => {
        this.table.current.reload();
    }


    render() {
        let { count } = this.state;
        let columns = [
            {
                title: 'Sr. No.',
                key: 'serialNumber',
                width: 80,
                render: (text, record, index) => index + 1,
            },
            {
                title: 'Employee Name',
                key: 'staffName',
                // searchTextName: 'staffName',
                // filterRegex:true
            },
            {
                title: 'In Time',
                key: 'inTime',
                render: (text, record) => (
                    record.inTime ?
                        record.inTime.map((time) => {
                            return (
                                <div key={time}>{moment(time).format('HH:mm A')}<hr /></div>
                            )
                        })
                        : null
                )
            },
            {
                title: 'Out Time',
                key: 'outTime',
                render: (text, record) => (
                    record.outTimeArr ?
                        record.outTimeArr.map((outTime) => {
                            let outTimeReason = null;
                            if(outTime.reason !== "Personal Work") {
                                outTimeReason = outTime && outTime.reason?outTime.reason.split('('):null;
                            }
                            return (
                                <div key={outTime.time}>{moment(outTime.time).format('HH:mm A')} - {outTime.reason === "Personal Work"?outTime.reason:outTimeReason && outTimeReason[0]}<hr /></div>
                            )
                        })
                        : null
                )
            },
            {
                title: 'Status',
                key: 'status',
                // filters:[{value:'IN', text:'IN'},{value:'OUT', text:'OUT'}],
                filterRegex:true
            },
            {
                title: 'Vision Status',
                key: 'visionStatus',
                render: (text, record) => (
                    record && record['login_history_details'] !== null ? 'Active' : 'Inactive'
                )
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <div>
                        {record && record.status === "IN" && record['login_history_details'] !== null ?
                            <Tooltip title="Out">
                                <Button shape="circle" icon="backward" size="small" onClick={() => { this.showOutDrawer(record) }} />
                            </Tooltip>
                            :
                            <Tooltip title="In">
                                <Button shape="circle" icon="forward" size="small" onClick={()=>{this.updateInStatus(record)}} />
                            </Tooltip>
                        }
                    </div>
                )
            }

        ]
        return (
            <PageHeaderWrapper title={`Staff In/Out Time :- ${count}`}>
                {
                    this.state.showOutDrawer ?
                        <StaffOutDetails record={this.state.record} onClose={this.closeOutDrawer} />
                        : null
                }
                <Card bordered={true} style={{ marginBottom: 10 }}>
                    <Row gutter={16}>
                        <Col span={8}>
                            <RangePicker
                                defaultValue={[moment(this.state.attendanceDate.from), moment(this.state.attendanceDate.to)]}
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            /></Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        // extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ["10", "20", "50", "100", "1000"],
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}




const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StaffInOutTime)